import React from "react";
import "./scrollup.css";

class ScrollUP extends React.Component{
  constructor(){
    super();
  }
  render(){
    return(
        <img onClick={this.props.scrollHome} src="/static/moveup.png" className={this.props.stickButton?"scroll_up stick_up":"scroll_up"}/>
    )
  }
}

export default ScrollUP;


// WEBPACK FOOTER //
// ./src/components/moveupButton/ScrollUp.js